import router from '../../router'
import ProgressService from '../../services/ProgressService'

const state = () => ({
    loadingProgress: false,
    progressGeneral: null,
    progress: null,
    detailedProgress: null,
})
  
const mutations = {
    SET_PROGRESS: (state, payload) => {
        state.progressGeneral = payload
    },
    SET_DETAILED_PROGRESS: (state, payload) => {
        state.detailedProgress = payload
    },
    SET_LOADING_PROGRESS: (state, payload) => {
        state.loadingProgress = payload
    },
}

const actions = {
    async fetchProgressGeneral({commit}){
        try{
            commit('SET_LOADING_PROGRESS', true)
            const response = await ProgressService.getGeneral();
            commit('SET_PROGRESS', response.data)
            commit('SET_LOADING_PROGRESS', false)
        } catch (error) {
            commit('SET_LOADING_PROGRESS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchProgress({commit}, id){
        try{
            commit('SET_LOADING_PROGRESS', true)
            const response = await ProgressService.getOne(id);
            commit('SET_PROGRESS', response.data)
            commit('SET_LOADING_PROGRESS', false)
        } catch (error) {
            commit('SET_LOADING_PROGRESS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    }
}

const getters = {
    getProgressGeneral: state => state.progressGeneral,
    getProgress: state => state.progress,
    getLoadingProgress: state => state.loadingProgress,
}

export default {
    state,
    getters,
    mutations,
    actions
};